import { TaskViewSettings } from "../types";

export class GetByParentTasksRequestModel {
  /**ID родительской подзадачи */
  ParentId!: number;
  /**ID очереди */
  QueueTaskId!: string;
  /**Настройки отображения */
  ViewSettings!: TaskViewSettings;

  constructor(obj?: Partial<GetByParentTasksRequestModel>) {
    Object.assign(this, obj);
  }
}
